// extracted by mini-css-extract-plugin
export var hideEditor = "_ka-2";
export var infoIcon = "_ka-3";
export var label = "_ka-1";
export var labelContainer = "_ka-0";
export var readonlyText = "_ka-4";